<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_2"></a>T<span class="small">HE</span> B<span class="small">ULGARI</span> C<span class="small">ONNECTION</span></h1>
<p class="author"><a id="page_3"></a>a novel by<br/>F<span class="small">AY</span> W<span class="small">ELDON</span></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?01ea84bb